// Module
var code = "<div class=\"visible-selected has-select condensed remove-top-padding clearfix\" ng-show=\"row.custom_data.length\">\n    <div class=\"assignment-tags\">\n        <span class=\"tag\" ng-repeat=\"field in row.custom_data\" ng-bind=\"'studentCustomFields.listCustomFieldLabel' | i18next:field\"></span>\n    </div>\n</div>\n";
// Exports
module.exports = code;